module.exports = __webpack_public_path__ + "img/colibertadorblanco.6ccad0b2.png";